// extracted by mini-css-extract-plugin
export default {"change-email":"EcardsListFooter_change-email__r88Vu","text":"EcardsListFooter_text__7z6UE","bottom-wrapper":"EcardsListFooter_bottom-wrapper__e49BJ"};